import React from "react";

import { Gauge } from "../components";
import { Barometer } from "../../types";
import clsx from "clsx";
import { peerReviewText } from "../../formatters";
import { EvidenceIcon } from "../components/evidence-icon";

interface Props {
  onClick: () => void;
  barometer: Barometer;
}

export default function Banner({ onClick, barometer }: Props) {
  return (
    <div className="w-full flex flex-col">
      <h2
        className="text-center text-3xl pb-1.5 cursor-pointer"
        onClick={onClick}
      >
        Videnskab.dk's Evidensbarometer
      </h2>
      <p className="text-center pb-3 cursor-pointer" onClick={onClick}>
        Hvor stærk evidens giver studiet omtalt i denne artikel?
      </p>
      <button
        onClick={onClick}
        className={clsx(
          "box-shadow m-3 mt-0 overflow-hidden rounded flex flex-1 ",
          {
            "bg-green":
              barometer.peer_reviewed === true,
            "bg-red-default":
              !barometer.peer_reviewed,
          }
        )}
      >
        <div className="flex flex-3 text-white justify-center items-center self-center">
          <EvidenceIcon
            className="h-6 w-6 white-icon mx-2"
            reviewed={barometer.peer_reviewed}
          />
          <span className="sm:text-lg text-base">
            {peerReviewText(barometer.peer_reviewed)}
          </span>
        </div>
        <div className="flex flex-2 bg-white justify-center items-center relative py-4">
          <div className="w-24 mx-auto">
            <Gauge evidence={barometer?.evidence_level} />
          </div>
          <img
            src={require("../../assets/icons/arrow.png")}
            className="w-3 mr-2 sm:absolute sm:right-3"
            alt="pil"
          />
        </div>
      </button>
    </div>
  );
}
